<nb-layout>
  <nb-layout-column class="p-0">
    <div class="row p-0 m-0">
      <div class="title-box">
        <div class="title-box__text">
          {{ "google-drive.title" | translate }}
        </div>
      </div>
    </div>

    <div class="row p-0 m-0 mt-5 d-flex justify-content-center">
      <nb-card class="p-0">
        <nb-card-body class="p-0">
          <div class="drive">
            <img srcset="assets/google/google_drive.png">
          </div>
          
          <div class="form">
            <span>{{ 'google-drive.description' | translate }}</span>
            <app-google-auth-button redirectTo="myFiles"></app-google-auth-button>
          </div>
        </nb-card-body>
      </nb-card>
  </div>
  </nb-layout-column>
</nb-layout>
